import { createRouter, createWebHistory } from "vue-router";
import AboutPage from "./pages/About.vue";
import QuizPage from "./pages/Quiz.vue";
import HomePage from "./pages/Home.vue";

const routes = [
  {
    path: "/",
    name: "HomePage",
    component: HomePage,
  },
  {
    path: "/quiz",
    name: "QuizPage",
    component: QuizPage,
  },
  {
    path: "/about",
    name: "AboutPage",
    component: AboutPage,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
